import { PreferenceTopicType } from '@transcend-io/privacy-types';

import type { PrivacyCenterPreferenceTopic } from '@main/cm-types';

import type { Preference } from '../PreferenceList';

/**
 * Convert preference topics to default set all values
 *
 * If Purpose is checked, then booleanValue is true, selectValue is first value, selectValues is all values
 * If Purpose is unchecked, then booleanValue is false, selectValue is empty string, selectValues is empty array
 *
 * @param preferenceTopics - Topic configurations
 * @param checked - Whether the purpose is checked
 * @returns return default preferences
 */
export function preferenceTopicsToDefaults(
  preferenceTopics: PrivacyCenterPreferenceTopic[],
  checked: boolean,
): Preference {
  return preferenceTopics.reduce(
    (acc, topic) =>
      Object.assign(acc, {
        [topic.slug]:
          topic.type === PreferenceTopicType.MultiSelect
            ? {
                selectValues: checked
                  ? topic.preferenceOptionValues.map(({ slug }) => slug)
                  : [],
              }
            : topic.type === PreferenceTopicType.Boolean
              ? {
                  booleanValue: checked,
                }
              : {
                  selectValue: checked
                    ? topic.preferenceOptionValues?.[0].slug
                    : null,
                },
      }),
    {} as Preference,
  );
}
